import React from "react";
import { Button } from "components/bootstrap";
import useForwarder from "../hooks/useForwarder";
import useForwarderInputState from "../hooks/useForwarderInputState";
import { ForwarderInputStatesActions } from "../stores/ForwarderInputStatesStore";
const ForwarderInputStateControl = ({ input }) => {
  var _a;
  const forwarderId = input.forwarder_id;
  const realInputId = input.input_id;
  const { data: forwarder } = useForwarder(forwarderId != null ? forwarderId : "");
  const { data: inputState } = useForwarderInputState(forwarderId != null ? forwarderId : "", realInputId);
  if (!forwarderId) {
    return null;
  }
  const forwarderForAction = {
    id: forwarderId,
    title: (_a = input.forwarder_title) != null ? _a : forwarderId
  };
  const inputForAction = {
    ...input,
    id: realInputId
  };
  if ((forwarder == null ? void 0 : forwarder.state) !== "CONNECTED") {
    return /* @__PURE__ */ React.createElement(Button, { bsStyle: "default", bsSize: "xsmall", disabled: true }, "Forwarder is not connected");
  }
  if ((inputState == null ? void 0 : inputState.state) === "RUNNING" || (inputState == null ? void 0 : inputState.state) === "FAILING") {
    return /* @__PURE__ */ React.createElement(
      Button,
      {
        bsStyle: "primary",
        bsSize: "xsmall",
        onClick: () => ForwarderInputStatesActions.stopInput(forwarderForAction, inputForAction)
      },
      "Stop input"
    );
  }
  const isStopped = (inputState == null ? void 0 : inputState.state) === "STOPPED" || (inputState == null ? void 0 : inputState.state) === "TERMINATED";
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: isStopped ? "default" : "primary",
      bsSize: "xsmall",
      onClick: () => ForwarderInputStatesActions.startInput(forwarderForAction, inputForAction)
    },
    "Start input"
  );
};
export default ForwarderInputStateControl;
